import { writable } from 'svelte/store';
import { applyTheme, loadTheme, persistTheme, type ThemeMode } from '@/lib/theme';

function createThemeStore() {
  const { subscribe, set, update } = writable<ThemeMode>('light');

  return {
    subscribe,
    init: () => {
      const mode = loadTheme();
      set(mode);
    },
    set: (mode: ThemeMode) => {
      persistTheme(mode);
      applyTheme(mode);
      set(mode);
    },
    toggle: () =>
      update((mode) => {
        const next: ThemeMode = mode === 'dark' ? 'light' : 'dark';
        persistTheme(next);
        applyTheme(next);
        return next;
      }),
  };
}

export const theme = createThemeStore();

